var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Typography } from '@material-ui/core';
import styled from 'styled-components';
const StyledDiv = styled.div `
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  padding: 12px 12px 8px 12px;
  .header-title {
    flex: 1;
  }
`;
export const ConfigHeader = (_a) => {
    var { className, end, children } = _a, props = __rest(_a, ["className", "end", "children"]);
    return (React.createElement(StyledDiv, Object.assign({ className: `config-header${className ? ` ${className}` : ''}` }, props),
        React.createElement(Typography, { variant: 'overline', className: 'header-title' }, children),
        end));
};
export default ConfigHeader;
//# sourceMappingURL=ConfigHeader.js.map